export const NA_VALUE = 'N/A';
export const FORMAT_GUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

